import axios from "axios";

type PageResp<T> = {
    content: T[];
    totalPages: number;
    totalElements: number;
    number: number;
    size: number;
    numberOfElements: number;
    first: boolean;
    last: boolean;
    empty: boolean;
};

export async function getInventoryReportRows(params: {
    from?: string;
    to?: string;
    tankId?: number;
    kpuId?: number;
    appObjectId?: number;
    sent?: boolean;
    acceptedByQoldau?: boolean;
    page: number;
    size: number;
    sort: string;
}) {
    const res = await axios.get<PageResp<any>>("/api/oiltrack/report/inventory", { params });
    return res.data;
}

export async function getInventoryDailySummary(params: {
    from?: string;
    to?: string;
    tankId?: number;
    kpuId?: number;
    appObjectId?: number;
}) {
    const res = await axios.get<any[]>("/api/oiltrack/report/inventory/daily-summary", { params });
    return res.data;
}
